var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M29.116 3.3a13.881 13.881 0 0 0-5.456-1.05c-5.774 0-11.547 2.922-17.32 2.922A14.222 14.222 0 0 1 2 4.529a1.6 1.6 0 0 0-.485-.076A1.492 1.492 0 0 0 0 5.944v14.871A1.491 1.491 0 0 0 .883 22.2a13.873 13.873 0 0 0 5.457 1.05c5.774 0 11.547-2.923 17.321-2.923A14.222 14.222 0 0 1 28 20.97a1.6 1.6 0 0 0 .485.076A1.492 1.492 0 0 0 30 19.555V4.684a1.493 1.493 0 0 0-.884-1.384zM2.25 6.948a16.312 16.312 0 0 0 2.94.419 3 3 0 0 1-2.94 2.415zm0 13.359v-2.24a3 3 0 0 1 2.986 2.878 11.324 11.324 0 0 1-2.986-.638zM15 17.25c-2.071 0-3.75-2.015-3.75-4.5s1.679-4.5 3.75-4.5 3.75 2.015 3.75 4.5-1.68 4.5-3.75 4.5zm12.75 1.3a16.117 16.117 0 0 0-2.546-.4 2.994 2.994 0 0 1 2.546-2.31zm0-11.067A2.994 2.994 0 0 1 25.134 4.6a11.268 11.268 0 0 1 2.616.593z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.d6adfe963484ff113d0b5ca975152df0.svg";
export { ForwardRef as ReactComponent };